export default "__VITE_ASSET__9d39ef1f__"